import { Directive, Host, Input, OnDestroy, OnChanges } from '@angular/core';

import { SortBySelectorComponent } from '../sort-by-selector/sort-by-selector.component';
import { SortByOption, SortByOptionHelper } from '../sort-by-selector/sort-by-selector.domain';
import { TableStateBaseDirective } from './table-state-base.directive';
import { TableStateService } from './table-state.service';

@Directive({
  selector: '[tdWbTableCardState]'

})
export class TableCardStateDirective extends TableStateBaseDirective implements OnChanges, OnDestroy {
  @Input('tdWbTableCardState')
  set tableId(value: string) {
    this.stateId = value;
  }

  constructor(tableStateService: TableStateService,
              @Host() private sortBySelectorComponent: SortBySelectorComponent) {
    super(tableStateService, sortBySelectorComponent.sortByChange);
  }

  ngOnChanges(): void {
    const sorts = this.getSorts();
    if (sorts !== undefined && sorts.length > 0) {
      this.sortBySelectorComponent.setSortBy(sorts[0]);
    }
  }

  ngOnDestroy(): void {
    this.destroy();
  }

  onSort(sort: SortByOption): void {
    this.setSorts([SortByOptionHelper.convertToTableSort(sort)]);
  }
}
